<template>
  <div class="quiz">
    <div class="quiz__mobile-header" :class="{ visible: showMobileHeader }">
      <container>
        <Header class="quiz__mobile-header-inner"></Header>
      </container>
    </div>
    <transition appear name="quiz" :duration="duration">
      <div class="quiz-content" key="intro" v-if="step === 'intro'">
        <intro></intro>
      </div>
      <div class="quiz-content" key="question" v-if="!busy && step === 'question'">
        <question></question>
      </div>
      <div class="quiz-content" key="final" v-if="!busy && step === 'final'">
        <final></final>
      </div>
    </transition>
  </div>
</template>

<script>
import { steps } from '@/store/index'
import Header from '@/components/Header.vue'

const components = {
  [steps.INTRO]: require('@/components/Quiz/Intro.vue').default,
  [steps.QUESTION]: require('@/components/Quiz/Question.vue').default,
  [steps.FINAL]: require('@/components/Quiz/Final.vue').default
}

export default {
  components: { ...components, Header },
  computed: {
    isLast () {
      return this.$store.getters.isLastStep
    },
    showMobileHeader () {
      if (this.current === 0) return false
      if (this.isLast) return false
      return this.step === 'intro' || this.busy
    },
    current () {
      return this.$store.state.current
    },
    step () {
      return this.$store.getters.step
    },
    busy () {
      return this.$store.state.busy
    },
    duration () {
      return this.$store.getters.duration
    },
    component () {
      return components[this.$store.getters.step]
    },
    key () {
      return `step_${this.$store.state.current}`
    }
  }
}
</script>

<style lang="scss">
  .quiz {
    position: relative;
    z-index: 1;
    height: 100vh;
  }

  .quiz__mobile-header {
    display: none;
    transition: 0.5s opacity, 0.5s transform, 0s visibility 0.5s;
    opacity: 0;
    visibility: hidden;
    transform: translateY(-100%);

    @include less(tablet) {
      display: block;
      background: $background;
      padding: 8px 0;
    }

    &.visible {
      opacity: 1;
      visibility: visible;
      transform: translateY(0);
      transition: 0.5s opacity, 0.5s transform;
    }
  }

  .quiz-content {
  }

  .quiz-enter-active {
    visibility: hidden;
  }
  .quiz-enter-to {
    visibility: visible;
  }
  .quiz-leave {
    visibility: visible;
  }
  .quiz-leave-active {
    visibility: hidden;
    transition: 0s visibility 1s
  }
</style>
